import { Injectable } from "@angular/core";
import { Http, Response, RequestOptions, Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { API_URL } from "../../constants";

import * as moment from "moment";
import { map, catchError } from "rxjs/operators";
import { of } from "rxjs/observable/of";
import storage from "../storage";

@Injectable()
export class ClientService {
    private baseUrl = API_URL;
    private loggedIn = null;
    private availableInRegion = null;
    private countryCode = null;

    constructor(private http: Http) {}

    initialize(): Promise<void> {
        return new Promise<void>((resolve) => {
            if (this.loggedIn !== null) {
                resolve();
                return;
            }

            const headers: Headers = new Headers();
            headers.set("Content-Type", "application/x-www-form-urlencoded");
            if (storage.getItem("token")) {
                headers.set("Authorization", "Bearer " + storage.getItem("token"));
            }
            this.http
                .get(
                    `${this.baseUrl}/test`,
                    new RequestOptions({
                        headers: headers,
                        withCredentials: true,
                    }),
                )
                .pipe(
                    map((res: any) => res.status),
                    catchError(() => {
                        this.loggedIn = false;
                        resolve();
                        return of(false);
                    }),
                )
                .subscribe((status) => {
                    this.loggedIn = status === 200 && !window.location.host.includes("spond.dev");
                    resolve();
                });
        });
    }

    resolveRegion(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.testRegion().subscribe(
                (res) => {
                    this.availableInRegion = true;
                    resolve();
                },
                (err) => {
                    this.availableInRegion = !err || err.status !== 403 || window.location.host.includes("spond.dev");
                    this.countryCode = err.headers.get("x-spond-requestgeoipcountrycode");
                    resolve();
                },
            );
        });
    }

    isLoggedIn(): boolean {
        return this.loggedIn;
    }

    isAvailableInRegion(): boolean {
        return this.availableInRegion;
    }

    getCountryCode(): string {
        return this.countryCode;
    }

    login(email: string, password: string): Observable<Response> {
        return this.http
            .post(
                `${this.baseUrl}/auth2/login`,
                {
                    email: email,
                    password: password,
                },
                new RequestOptions({
                    withCredentials: true,
                    headers: {
                        "X-Spond-CountryCode": navigator.language,
                    } as any,
                }),
            )
            .pipe(map((res: any) => res.json()));
    }

    verify2fa(token: string, code: string, phoneNumber: string): Observable<Response> {
        return this.http
            .post(`${this.baseUrl}/auth2/2fa/verify`, { token, code, phoneNumber })
            .pipe(map((res: any) => res.json()));
    }

    resendCode(token: string): Observable<Response> {
        return this.http.post(`${this.baseUrl}/auth2/2fa/resend`, { token }).pipe(map((res: any) => res.json()));
    }

    register(
        email: string,
        firstName: string,
        lastName: string,
        password: string,
        locale: string,
        dateOfBirth: string,
        gender: string,
        intMarketing: boolean,
        extMarketing: boolean,
        referralCode: string,
    ) {
        const payload = {
            email,
            firstName,
            lastName,
            password,
            locale,
            intMarketing,
            extMarketing,
            dateOfBirth,
        };

        if (gender) {
            payload["gender"] = gender;
        }
        if (referralCode) {
            payload["referralCode"] = referralCode;
        }
        return this.http.post(`${this.baseUrl}/auth2/login/create`, payload).pipe(map((res: any) => res.json()));
    }

    resetPassword(email: string, phoneNumber: string) {
        const data = email ? { email } : { phoneNumber };
        return this.http.post(`${this.baseUrl}/auth2/login/reset`, data).pipe(map((res: any) => res.json()));
    }

    updateLogin(phoneNumber: string, resetCode: string, password: string) {
        return this.http
            .put(`${this.baseUrl}/auth2/login`, {
                phoneNumber: phoneNumber,
                resetCode: resetCode,
                password: password,
            })
            .pipe(map((res: any) => res.json()));
    }

    subscribe(email: string, type: number, extra: string) {
        let params: any = {
            email: email,
        };

        if (extra) {
            params.extra = extra;
        }

        return this.http.post(`${this.baseUrl}/subscribe/${type}`, params).pipe(map((res: any) => res.json()));
    }

    testRegion() {
        return this.http.get(`${this.baseUrl}/test/region`);
    }
}
